<template>
  <v-container fluid grid-list-lg>
    <Create
      :createDialog="createDialog"
      @close="createDialog = false"
      @submit="getList"
    ></Create>
    <Edit
      :editDialog="editDialog"
      @close="editDialog = false"
      @submit="getList"
      :editEvent="selectedEvent"
    ></Edit>
    <v-card :loading="loading" outlined>
      <ListTitle
        :showBackButton="true"
        :access="checkRightStatus(69)"
        title="Event"
        @add="add"
      />

      <v-card-title>
        <v-flex xs12 sm4>
          <v-text-field
            v-model="search"
            outlined
            prepend-inner-icon="search"
            rounded
            dense
            label="Search"
            single-line
            hide-details
            clearable
          ></v-text-field>
        </v-flex>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="Events"
        :search="search"
        :loading="loading"
        :sort-by="sortBy"
        :page.sync="page"
        :items-per-page="itemsPerPage"
      >
        <template v-slot:item="{ item }">
          <tr class="pointer">
            <td class="text-left" @click="viewEvent(item)">{{ item.createdAt | moment("LL LT") }}</td>
            <td class="text-left" @click="viewEvent(item)">{{ item.name }}</td>
            <td class="text-left">
              <!-- <div >http://localhost:8082/e/{{ item.id }}</div> -->
              <div>https://portal.taleem.app/e/{{ item.id }}</div>
            </td>
            <td class="text-center" @click="viewEvent(item)">{{ item.submitCount }}</td>
            <td class="justify-end align-center text-right">
              <v-menu bottom left offset-y>
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" icon>
                    <v-icon>more_vert</v-icon>
                  </v-btn>
                </template>
                <v-list class="menu-button">
                  <v-list-item
                    @click="viewEvent(item)"
                  >
                    <v-list-item-title>View</v-list-item-title>
                  </v-list-item>
                  <v-divider></v-divider>
                  <v-list-item
                    v-if="checkRightStatus(71)"
                    @click="editEvent(item)"
                  >
                    <v-list-item-title>Edit</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="checkRightStatus(72)"
                    @click="deleteEvent(item)"
                  >
                    <v-list-item-title>Delete</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </td>
          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning"
          >Your search for "{{ search }}" found no results.</v-alert
        >
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import EventService from "../service";
import { mapGetters } from "vuex";
import Hashids from "hashids";
const hashids = new Hashids();

const Create = () => import("./Create");
const Edit = () => import("./Edit");
export default {
  name: "Event-list",
  data() {
    return {
      createDialog: false,
      editDialog: false,
      selectedEvent: null,
      headers: [
        {
          text: 'Created At',
          align: "left",
          value: "createdAt",
          sortable: true,
        },
        {
          text: "Name",
          align: "left",
          value: "name",
          sortable: true,
        },
        {
          text: "Link",
          align: "left",
          value: "name",
          sortable: true,
        },
        {
          text: "Submit Count",
          align: "center",
          value: "name",
          sortable: false,
        },
        {
          text: "",
          value: "action",
          sortable: false,
        },
      ],
      currentEnvironment: process.env.VUE_APP_NODE_ENV || 'Unknown',
      Events: [],
      search: null,
      loading: true,
      page: 1,
      sortBy: "balance",
      pageCount: 0,
      itemsPerPage: 10,
    };
  },
  created() {
    this.getList();
    document.title = "taleem - Event List";
  },
  components: {
    Create,
    Edit,
  },
  computed: {
    ...mapGetters("global", ["currentUser", "checkRightStatus"]),
  },
  methods: {
    add() {
      this.createDialog = !this.createDialog;
    },
    getList() {
      this.loading = true;
      (this.editDialog = false), (this.createDialog = false);
      return EventService.getAll().then((response) => {
        console.log('response', response)
        this.loading = false;
        this.Events = response.data;
        return response;
      });
    },
    editEvent(Event) {
      this.selectedEvent = Event;
      this.editDialog = !this.editDialog;
    },
    viewEvent(event){
      const hashId = hashids.encode(event.id);
      const routeData = this.$router.resolve({
        path: `/global/events/${hashId}/view`,
      });
      window.open(routeData.href, "newwindow", "width=850, height=1100");
    },
    deleteEvent(Event) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#B71C1C",
        cancelButtonColor: "#43A047",
        cancelButtonText: "No",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.value) {
          EventService.delete(Event.id).then((response) => {
            if (response.data) {
              this.$swal("Deleted!", "Event has been deleted.", "success");
              this.getList();
            }
          });
        }
      });
    },
  },
};
</script>
